import React from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";

interface ButtonProps {
  id?: any;
  setShowModal: any;
  side?: any;
}

const FloatingButton: React.FC<ButtonProps> = ({ id, setShowModal, side }) => {

  return (
    <Button
      className={`btn btn-primary position-fixed bottom-0 end-${side ? side : '0'} mb-3 me-3 rounded-circle d-flex align-items-center justify-content-center 
        ${(id && id ? '' : 'd-none')}`}
      style={{ width: "75px", height: "75px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
      aria-label="Adicionar"
      onClick={() => setShowModal(true)}
    >
      <FontAwesomeIcon icon={faPlus} className="fa-xl" />
    </Button>
  )
}

export default FloatingButton